export class BelongsToField{
    code:string;
    name:string;
  }
